import {
    FILTER_PINNED,
    FILTER_NOT_PINNED,
    FILTER_FEATURE_SCOOTER_LIST,
    FILTER_FEATURE_SCOOTER_MAP,
    FILTER_FEATURE_TICKET_LIST,
    FILTER_FEATURE_TICKET_ASSIGNMENT,
    FILTER_FEATURE_ADDITIONAL_FEE,
    FILTER_OVER_LIMITED_SIZE,
    FILTER_FILE_INVALID,
    FILTER_FILE_EMPTY,
    FILTER_NOT_EXISTS,
    FILTER_UNAUTHED,
    DELETE_UNAUTHED_FILTERS,
    DELETE_UNEXIST_FILTERS,
    FILTER_OVER_PIN_SIZE,
    FILTER_CRITERIA_ERROR,
    FILTER_NOT_FOUND,
    FILTER_FLEET_USR_NOT_MATCH,
} from 'constants/filters';

import {
    SCOOTER_LIST,
    SCOOTER_MAP,
    TICKET_LIST,
    TICKET_ASSIGNMENT,
    ADDITIONAL_FEE
} from 'constants/routes';

import routes from './routes';

const pinnedMap = {
    [FILTER_PINNED]: '是',
    [FILTER_NOT_PINNED]: '否',
};

const featuresMap = {
    [FILTER_FEATURE_SCOOTER_LIST]: routes[SCOOTER_LIST],
    [FILTER_FEATURE_SCOOTER_MAP]: routes[SCOOTER_MAP],
    [FILTER_FEATURE_TICKET_LIST]: routes[TICKET_LIST],
    [FILTER_FEATURE_TICKET_ASSIGNMENT]: routes[TICKET_ASSIGNMENT],
    [FILTER_FEATURE_ADDITIONAL_FEE]: routes[ADDITIONAL_FEE],
};

const filters = {
    'shortcut_title': '你置頂的篩選器',
    'go_to_filters_management': '管理篩選器',
    'empty_filters': '目前沒有設定置頂篩選器',
    'search_box_placeholder': '輸入篩選器名稱',
    'filter_feature': '功能頁面',
    'filter_pinned': '置頂',
    'pinned_map': pinnedMap,
    'features_map': featuresMap,
    'new': '新增篩選器',
    'result': '篩選頁面',
    'update_time': '更新時間',
    'link': '連結',
    'name': '篩選器名稱',
    'id': '篩選器編號',
    'export_title': '請在下方貼上來源的篩選器編號：',
    'browse_file': '瀏覽檔案',
    [`import_error_${ FILTER_OVER_LIMITED_SIZE }`]: '超過可建立的篩選器數量 (最多 200 筆)',
    [`import_error_${ FILTER_FILE_INVALID }`]: '無效的檔案 (請確保檔案為 csv 檔並且標頭與範本相同)',
    [`import_error_${ FILTER_FILE_EMPTY }`]: '無效的檔案 (檔案無法找到篩選器編號)',
    [`import_error_${ FILTER_NOT_EXISTS }`]: '篩選器不存在: %{filterId}',
    [`import_error_${ FILTER_UNAUTHED }`]: '你沒有權限匯入此篩選器，請確認你的篩選器功能及你的用戶權限: %{filterId}',
    'remove': '刪除',
    'confirm_remove': '確定刪除選擇的篩選器嗎？',
    [`delete_error_${DELETE_UNAUTHED_FILTERS}`]: '你沒有權限刪除此篩選器，請確認你的篩選器功能及你的用戶權限。',
    [`delete_error_${DELETE_UNEXIST_FILTERS}`]: '此篩選器已不存在',
    'filter_detail_title': '篩選器詳情',
    'details': '詳細資料',
    'description': '描述',
    'criteria_sorting': '排序',
    'criteria_filters': '篩選器',
    [`create_upd_error_${ FILTER_OVER_LIMITED_SIZE }`]: '超過可建立的篩選器數量 (最多 200 筆)',
    [`create_upd_error_${ FILTER_OVER_PIN_SIZE }`]: '超過可以置頂的數量',
    [`create_upd_error_${ FILTER_CRITERIA_ERROR }`]: '請移除已失效的排序或篩選器選項後再更新一次。',
    [`create_upd_error_${ FILTER_UNAUTHED }`]: '你的權限已無法編輯該篩選器，請確認你的篩選器功能及你的用戶權限',
    [`create_upd_error_${ FILTER_FLEET_USR_NOT_MATCH }`]: '非使用者建立的篩選器',
    [`create_upd_error_${ FILTER_NOT_FOUND }`]: '此篩選器已不存在',
    'invalid': '失效',
    'criteria_can_not_edit': '點擊編輯按鈕以修改排序跟篩選器設定',
};

export default filters;
